import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { toast } from '@/lib/toast'

export function useMyTags() {
  return useQuery({
    queryKey: ['my-tags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('resident_tags')
        .select('*, tag:tags(id, code, label, description, display_color, metadata_schema, scope_type)')
        .order('created_at')
      if (error) throw error
      return data ?? []
    },
  })
}

export function useAvailableTags() {
  return useQuery({
    queryKey: ['available-tags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tags')
        .select('id, code, label, description, display_color, metadata_schema, scope_type')
        .eq('is_active', true)
        .neq('code', 'SENIOR')
        .order('display_order')
      if (error) throw error
      return data ?? []
    },
  })
}

export function useAssignTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ tagId, metadata }: { tagId: string; metadata: Record<string, unknown> }) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Not authenticated')
      const { error } = await supabase.from('resident_tags')
        .insert({ resident_id: session.user.id, tag_id: tagId, metadata, is_verified: false })
      if (error) throw error
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-tags'] })
      toast.success('Tag requested. Your barangay admin will verify it.')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useRemoveTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (residentTagId: string) => {
      const { error } = await supabase.from('resident_tags').delete().eq('id', residentTagId)
      if (error) throw error
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['my-tags'] })
      toast.success('Tag removed')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}
